import PropTypes from 'prop-types';
import {Notification as NotificationToast, options} from 'ui/toastify/notification';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {getLastNotificationSelector, getNotificationsEnabledSelector} from 'api/notifications';
import {toast} from 'react-toastify';

const BellIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0002 0C13.6897 0 15.0697 1.32672 15.1545 2.99512L15.1584 3.1582C18.1425 4.40914 20.1127 7.28393 20.2082 10.501L20.2111 10.7363V11.6943C20.2016 14.9594 21.4995 18.0931 23.8146 20.3955C23.9952 20.5761 24.0491 20.848 23.9513 21.084C23.8644 21.2935 23.673 21.4381 23.4523 21.4678L23.3683 21.4736H15.0949C14.7948 22.9439 13.5009 24 12.0002 24C10.5535 23.9997 9.29948 23.018 8.94256 21.6299L8.90642 21.4736H0.632009C0.376729 21.4735 0.145765 21.3198 0.0480247 21.084C-0.0496146 20.8482 0.0044158 20.5761 0.184743 20.3955C2.42546 18.1673 3.71352 15.1608 3.78631 12.0098L3.78924 11.6943V10.7363C3.79301 7.50362 5.69232 4.58181 8.62615 3.25879L8.84295 3.16504C8.84295 1.41438 10.2563 0.000340714 12.0002 0ZM9.72185 21.4404C9.99211 22.4711 10.9237 23.2 12.0002 23.2002C13.072 23.2002 14.0025 22.4785 14.2775 21.4551L14.2814 21.4404H9.72185ZM12.0002 0.799805C10.7439 0.800069 9.7184 1.78244 9.64666 3.02539L9.64275 3.16504V3.69824L9.15056 3.90332C6.46413 5.02358 4.68857 7.60818 4.59392 10.502L4.59002 10.7363V11.6924C4.59881 14.9539 3.38353 18.0918 1.20037 20.4912L1.0617 20.6396H22.9377L22.801 20.4922C20.6895 18.1715 19.4837 15.1624 19.4142 12.0205L19.4113 11.6943V10.7373C19.4079 7.8276 17.7037 5.19521 15.0656 3.99023L14.8488 3.89551L14.3586 3.69043V3.1582C14.3586 1.85599 13.3025 0.799805 12.0002 0.799805Z"
      fill="white"
    />
  </svg>
);

const BellActiveIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0002 0C13.6897 0 15.0697 1.32672 15.1545 2.99512L15.1584 3.1582C18.1425 4.40914 20.1127 7.28393 20.2082 10.501L20.2111 10.7363V11.6943C20.2016 14.9594 21.4995 18.0931 23.8146 20.3955C23.9952 20.5761 24.0491 20.848 23.9513 21.084C23.8644 21.2935 23.673 21.4381 23.4523 21.4678L23.3683 21.4736H15.0949C14.7948 22.9439 13.5009 24 12.0002 24C10.5535 23.9997 9.29948 23.018 8.94256 21.6299L8.90642 21.4736H0.632009C0.376729 21.4735 0.145765 21.3198 0.0480247 21.084C-0.0496146 20.8482 0.0044158 20.5761 0.184743 20.3955C2.42546 18.1673 3.71352 15.1608 3.78631 12.0098L3.78924 11.6943V10.7363C3.79301 7.50362 5.69232 4.58181 8.62615 3.25879L8.84295 3.16504C8.84295 1.41438 10.2563 0.000340714 12.0002 0ZM9.72185 21.4404C9.99211 22.4711 10.9237 23.2 12.0002 23.2002C13.072 23.2002 14.0025 22.4785 14.2775 21.4551L14.2814 21.4404H9.72185ZM12.0002 0.799805C10.7439 0.800069 9.7184 1.78244 9.64666 3.02539L9.64275 3.16504V3.69824L9.15056 3.90332C6.46413 5.02358 4.68857 7.60818 4.59392 10.502L4.59002 10.7363V11.6924C4.59881 14.9539 3.38353 18.0918 1.20037 20.4912L1.0617 20.6396H22.9377L22.801 20.4922C20.6895 18.1715 19.4837 15.1624 19.4142 12.0205L19.4113 11.6943V10.7373C19.4079 7.8276 17.7037 5.19521 15.0656 3.99023L14.8488 3.89551L14.3586 3.69043V3.1582C14.3586 1.85599 13.3025 0.799805 12.0002 0.799805Z"
      fill="white"
    />
    <circle cx="19.9995" cy="9" r="3.5" fill="url(#paint0_linear_2024_2544)" stroke="white" />
    <defs>
      <linearGradient
        id="paint0_linear_2024_2544"
        x1="16.9995"
        y1="6"
        x2="16.9995"
        y2="12"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#E2B985" />
        <stop offset="1" stopColor="#B07F51" />
      </linearGradient>
    </defs>
  </svg>
);

const NotificationBell = ({notificationsEnabled, lastNotification}) => {
  if (!notificationsEnabled) {
    return null;
  }

  if (lastNotification) {
    return (
      <div
        onClick={() => toast(<NotificationToast latestNotification={lastNotification.acf} />, options)}
        style={{cursor: 'pointer', display: 'flex'}}>
        <BellActiveIcon />
      </div>
    );
  }

  return (
    <div style={{display: 'flex'}}>
      <BellIcon />
    </div>
  );
};

NotificationBell.propTypes = {
  notificationsEnabled: PropTypes.bool.isRequired,
  lastNotification: PropTypes.object,
  parent: PropTypes.string.isRequired,
};

export default NotificationBell
  |> connect(
    createStructuredSelector({
      notificationsEnabled: getNotificationsEnabledSelector,
      lastNotification: getLastNotificationSelector,
    }),
  );
